// @flow
import * as React from 'react';
import styled from 'styled-components';
import CountdownTimer from "../../../components/CountdownTimer";
import colors from '../../../assets/css/colors';

const DraftTurnTimerWrapper = styled.div`
	padding: 15px 25px;
	background: #FFF;
	display: flex;
	min-width: 320px;
	flex-wrap: nowrap;
	align-items: center;
	justify-content: space-between;
	color: ${colors.nrlDarkGreen};

	.timer {
		justify-content: flex-end;
		margin-left: 15px;

		& > div {
			padding: 6px .5em 0;
			margin: 0 0 0 2px;
		}
	}

	&.is-my-turn {
		background: ${colors.nrlGreen};

		.timer-unit {
			color: #FFF;
		}

		.timer-label {
			color: #FFF;
		}

		.timer > div{
			border-radius: 1px;
			background: rgba(0, 0, 0, .15);
		}
	}

	.timer-label {
		text-transform: uppercase;
		margin: 0;
		padding-top: 2px;
	}

	.pick-counter {
		background: ${colors.nrlDarkGreen};
		color: #FFF;
		text-transform: uppercase;
		font-size: 14px;
		font-weight: bold;
		display: inline-block;
		padding: 2px 4px;
		border-radius: 3px;
		margin-right: 3px;
	}

	p {
		font-weight: bold;
		margin-bottom: 7px;
		white-space: nowrap;
	}

	.current-pick-team-name {
		font-size: 12px;
		font-weight: bold;
		margin-right: 5px;
		max-width: 150px;
		display: inline-block;
		overflow: hidden;
		text-overflow: ellipsis;
	}

	.current-pick-user-name {
		font-size: 12px;
		color: ${colors.darkGrey};
		max-width: 150px;
		display: inline-block;
		overflow: hidden;
		text-overflow: ellipsis;
	}

	.current-pick-holder {
		white-space: nowrap;
	}
	@media screen and (max-width: 640px){
		padding: 15px 0px 15px 15px;
		min-width: 260px;
	}
`;

type Props = {
	nextPickAt: string,
	isMyTurn: boolean,
	lastPick?: Object,
	user?: Object,
}

export class DraftTurnTimer extends React.Component<Props> {
	shouldComponentUpdate(nextProps: Props): boolean {
		return this.props.nextPickAt !== nextProps.nextPickAt;
	}

	render() {
		const {
			nextPickAt,
			isMyTurn,
			lastPick,
			user = {},
			...rest
		} = this.props;

		return lastPick ? (
			<DraftTurnTimerWrapper className={isMyTurn ? 'is-my-turn' : ''} {...rest}>
				<div className="current-pick-holder">
					<p>
						<span className="pick-counter">
							{`Pick ${lastPick.pick}`}
						</span> is on the Clock
					</p>
					{ isMyTurn ? (
						<b className="current-pick-team-name">It's your pick!</b>
					) : (
						<div>
							<b className="current-pick-team-name">{ lastPick.turn_team_name }</b>
							{' '}
							<span className="current-pick-user-name">
								{ user.firstname && user.lastname ? (
									`${user.firstname} ${user.lastname[0]}.`
								) : null }
							</span>
						</div>
					) }
				</div>
				<CountdownTimer
					className="timer"
					showOnComplete={true}
					hideHoursIfZero={true}
					date={nextPickAt}
				/>
			</DraftTurnTimerWrapper>
		) : null;
	}
}

export default DraftTurnTimer;


// WEBPACK FOOTER //
// ./src/pages/league/liveDraft/draftTurnTimer.js